import { CSInterface } from "csinterface-ts";
import { runEvalScript } from "../helpers/runEvalScritp";
import { rootStore } from "../../store/root";
import { jsxConstsEvents, jsxConstFunctions } from "../jsxConsts";
import { runAfterRender } from "../scripts/runAfterRender";
import { testBeforeRender } from "../scripts/render";
import { deleteTmpDir } from "../helpers/tmpDir";
import { analyticsInstance } from "../../analytics/analyticsCtrls";

const { csInterface }: { csInterface: CSInterface } = window as any;

export function renderCompleteListener() {
  csInterface.addEventListener(
    jsxConstsEvents.renderComplete,
    async (data: any) => {
      const {
        renderStore: { setCompJson, uploadAllAssets },
        projectStore: { selectedSceneExists },
        compositionStore: {
          compositionCurrentlyRendering,
          setRenderedCompositions,
        },
      } = rootStore;
      const jsonData: any = await runEvalScript(jsxConstFunctions.getJsonData);
      setCompJson(jsonData);
      const currentComposition = compositionCurrentlyRendering;
      // If we are creating the scene for the first time
      if (currentComposition) {
        if (!selectedSceneExists(currentComposition.name)) {
          analyticsInstance.sendAnalytics("scene", { val: "create", sceneName: currentComposition.name });
        }
        await uploadAllAssets(currentComposition.name || "");
      }
      const compId = currentComposition.id || 0;
      const { beforeRenderState } = rootStore.renderStore;
      rootStore.renderStore.setRenderedAssetsTypes([]);
      rootStore.renderStore.clearImagesToUpload();
      rootStore.renderStore.clearUploadedImages();
      deleteTmpDir(rootStore.renderStore.filesFolderPath);
      await runAfterRender(compId, beforeRenderState);
      setRenderedCompositions(currentComposition.id);
      rootStore.renderStore.setBeforeRenderState({});
      testBeforeRender();
    }
  );
}
